import { render } from "./Apropos.vue?vue&type=template&id=0cb6075c&scoped=true"
import script from "./Apropos.vue?vue&type=script&lang=js"
export * from "./Apropos.vue?vue&type=script&lang=js"

import "./Apropos.vue?vue&type=style&index=0&id=0cb6075c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cb6075c"

export default script